export default __webpack_public_path__ + "static/stiftungs-logo-einzeilig-bbac1218decf8dadec6d15bc604d5dc1.png";